import { render, staticRenderFns } from "./TeamAnswers.vue?vue&type=template&id=af8bb23e&scoped=true&"
import script from "./TeamAnswers.vue?vue&type=script&lang=js&"
export * from "./TeamAnswers.vue?vue&type=script&lang=js&"
import style0 from "./TeamAnswers.vue?vue&type=style&index=0&id=af8bb23e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8bb23e",
  null
  
)

export default component.exports